<template>
  <div class="signInDetail">
    <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
    <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>

    <div class="mobileHeader">
      <p>
        <span style="margin-right: 10%"
          >申请单号：{{ list.addServicesNo }}</span
        >
      </p>
      <p>
        <span>参考单号：{{ list.relationNumber }}</span>
      </p>
      <p>
        <span>服务类型: {{ list.feeTypeName }}</span>
        <span>客户: {{ list.customName }}</span>
      </p>
      <p>
        <span>期望时间: {{ list.ecTimeDesc }}</span>
        <span>是否有附件: {{ list.fileQty>0?"是":"否" }}</span>
      </p>
      <p>
        <span>操作说明: {{ list.servicesRemark }}</span>
        <span>箱数: {{ list.boxCount }}</span>
      </p>
    </div>

    <div class="sign-item">
      <van-form @submit="onSubmit">
        <div>
          <span>操作数量</span>
          <van-field
            v-model="list.doneQty"
            type="digit"
            maxlength="10"
            :max="1000"
            placeholder="操作数量"
            :rules="[{ required: true, message: '请填写操作数量' }]"
          />
        </div>
        <div>
          <span>操作时间</span>
          <van-field
            readonly
            clickable
            v-model="list.doneTime"
            placeholder="点击选择时间"
            :rules="[{ required: true, message: '请选择操作时间' }]"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
              confirm-button-text="确定"
              cancel-button-text="取消"
              v-model="currentDate"
              type="datetime"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
        </div>
        <div>
          <span>仓库备注</span>
          <van-field
            v-model="list.doneRemark"
            rows="2"
            autosize
            type="textarea"
            maxlength="200"
            placeholder="请输入备注"
            show-word-limit
          />
        </div>
        <div>
          <p class="p-title">操作照片</p>
          <div class="photo">
            <div class="sign-photo-cpntent">
              <div class="sign-photo-box">
                <ul>
                  <li
                    class="sign-photo-item"
                    v-for="(item, index) in skuImg"
                    :key="index"
                  >
                    <span class="delete-icon" @click="deleteImg(index)">x</span>
                    <img
                      :src="item"
                      class="sign-photo-item-img"
                      alt=""
                      @click="previewImage(item)"
                    />
                  </li>

                  <li class="sign-photo-btn">
                    <div class="photo">
                      <input
                        class="img hidden"
                        @change="changeImg()"
                        type="file"
                        name="cover"
                        ref="inputer"
                        accept="image/*"
                        multiple
                      />
                      <p @click="chooseImage">
                        <i class="el-icon-camera"></i>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div>
          <van-button
            class="signInDetail-receipt"
            round
            block
            type="info"
            native-type="submit"
            >确认完成</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import {
  Field,
  Toast,
  Form,
  Button,
  Popup,
  DatetimePicker,
  Uploader,
  ImagePreview,
} from "vant";
import util from "util/date";
import axios from "axios";
import { BaseApiUrl } from "@/api/axios_config";
import {
  getDeliveryNo,
  submitSignFor,
} from "@/api/mobile/jy-valueAddedServices_api";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      list: {
        doneTime: this.getToday(),
      },
      currentDate: new Date(),
      itemArr: ["本次签收数量"],
      showPicker: false,
      skuImg: [],
      imgFiles: [],
      saveImgUrlArr: [],
    };
  },

  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Uploader.name]: Uploader,
    [ImagePreview.name]: ImagePreview,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  methods: {
    deleteImg(i) {
      this.skuImg.splice(i, 1);
      // this.imgFiles.splice(i,1)
      this.saveImgUrlArr.splice(i, 1);
    },

    changeImg() {
      const img = document.getElementsByClassName("img")[0];
      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.handleFiles(imgList);

      this.submitImg();
    },

    chooseImage() {
      document.getElementsByClassName("img")[0].click();
    },

    // 预览图片
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true,
      });
    },

    handleFiles(files) {
      const that = this;
      let srcArr = []; // 保存转换的base64 imgFileUrl

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const { type, name } = file;

        var imageType = /^image\//;
        if (!imageType.test(type)) {
          continue;
        }

        var reader = new FileReader();
        reader.onload = function (e) {
          that.$set(that.skuImg, that.skuImg.length, e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },

    submitImg() {
      const that = this;

      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      Toast.loading({
        message: "保存中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        Toast.clear();
        if (res.data.status === 200 && res.data.success) {
          this.saveImgUrlArr.push(...res.data.response);
          this.imgFiles = [];
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    onConfirm(time) {
      this.$set(
        this.list,
        "doneTime",
        util.formatDate.format(time, "yyyy-MM-dd")
      );
      this.showPicker = false;
    },
    init() {
      this.getDeliveryNo();
    },
    getToday() {
      var currentDate = new Date();
      var year = currentDate.getFullYear();
      var month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
      var day = ("0" + currentDate.getDate()).slice(-2);
      var hours = ("0" + currentDate.getHours()).slice(-2);
      var minutes = ("0" + currentDate.getMinutes()).slice(-2);

      var formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
      return formattedDate;
    },
    getDeliveryNo() {
      const { tfAddServicesID } = this.$route.query;
      const data = {
        tfAddServicesID,
      };

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getDeliveryNo(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          const { response } = res;

          try {
            response.estimatedDate = util.formatDate.format(
              new Date(response.estimatedDate),
              "yyyy-MM-dd"
            );
          } catch {}
          this.list = {
            ...response,
            doneTime: this.getToday(),
          };
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    checkParam() {
      const { singleBoxQty } = this.list;
      const obj = {
        singleBoxQty,
      };

      const valueArr = Object.values(obj);
      for (let i = 0; i < valueArr.length; i++) {
        const v = valueArr[i];
        if (v === 0 || v === "0.000" || v === "0.0" || !v) {
          Toast(`请输入${this.itemArr[i]}`);
          return false;
        }
      }
    },
    showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    onSubmit() {
      const that = this;
      const { tfAddServicesID, doneQty, doneTime, doneRemark } = this.list;
      if (this.saveImgUrlArr.length === 0) {
        this.showsound(false);
        return Toast("请上传操作照片");
      }
      const data = {
        tfAddServicesID,
        doneQty,
        doneTime,
        doneRemark,
        file: this.saveImgUrlArr,
      };

      Toast.loading({
        message: "操作中...",
        forbidClick: true,
      });

      submitSignFor(data).then((res) => {
        Toast.clear();

        if (res.status === 200) {
          this.showsound(true);
          Toast.success("操作成功");
          setTimeout(function () {
            that.$router.go(-1);
          }, 1500);
        } else {
          this.showsound(false);
          Toast.fail(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.signInDetail .mobileHeader {
  padding: 0 10px 15px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;

  > p {
    display: flex;

    > span {
      flex: 1;
    }
  }
}

.sign-item {
  background-color: #fbf9fe;

  .van-form {
    > div {
      display: flex;
      gap: 10px;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 10px;

      .van-cell {
        flex: 1;
        border: 1px solid #ccc;
      }
    }
  }

  padding: 10px;

  .signInDetail-content {
    font-size: 15px;
  }

  .signInDetail-btnBox {
    li {
      line-height: 40px;
      white-space: nowrap;
      display: flex;
      align-items: baseline;
    }

    .volume {
      min-width: 10%;
      max-width: 17%;
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      border: 1px solid #ccc;
      outline: none;
      margin: 0 5px;
      padding: 0 5px;
      box-sizing: border-box;
    }

    .van-cell {
      margin-left: 10px;
      border: 1px solid #adadad;
      flex: 1;
    }
  }
}

.signInDetail-receipt {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  margin-top: 20px;
  font-size: 18px;
  border: 0;
}

.btn {
  width: 35%;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 14px;
  border: 0;
  height: 25px;
  line-height: 25px;
}

.sign-photo-box {
  border: 1px solid #797979;
  box-sizing: border-box;

  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }

      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }

    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;

      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;

        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;

          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

::v-deep .van-icon-photo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.sign-photo-box {
  box-sizing: border-box;
  border: none;

  ul {
    .sign-photo-item {
      width: 30.333%;
      height: 100px;
      border: 5px solid #ccc;
      box-sizing: border-box;
      position: relative;
      float: left;
      margin: 0 4.5% 4.5% 0;
      line-height: 127px;
      overflow: hidden;
      box-shadow: 0px 0px 7px -1px #cccccc;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .delete-icon {
        position: absolute;
        background: red;
        color: #fff;
        width: 16px;
        height: 16px;
        top: 0px;
        right: 0px;
        line-height: 16px;
        font-size: 12px;
        border-radius: 16px;
        text-align: center;
      }

      .sign-photo-item-img {
        width: auto;
        height: 100%;
      }
    }

    .sign-photo-btn {
      display: inline-block;
      vertical-align: top;
      width: 30.333%;

      .photo {
        height: 100px;
        background-color: #faf9fc;
        position: relative;
        box-shadow: 0px 0px 7px -1px #cccccc;

        p {
          border: 1px dashed #ccc;
          padding: 10px;
          width: 50px;
          height: 50px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0;

          i {
            font-size: 40px;
            color: #ccc;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

.sign-photo-save {
  padding: 0 10px;
}

.photo {
  font-size: 14px;
  flex: 1;
}

.fl {
  flex: 1 1 0%;
  max-width: 100% !important;
}

.hidden {
  display: none;
}

@media screen and (max-width: 360px) {
  .signInDetail-btnBox {
    li {
      font-size: 14px;
    }
  }
}
</style>
